import { apiRequest } from "./api";

export function getBiometricDevices(accessToken) {
  return apiRequest("/biometric-devices", { accessToken });
}

export function getBiometricDevice(deviceId, accessToken) {
  return apiRequest(`/biometric-devices/${deviceId}`, { accessToken });
}

export function createBiometricDevice(body, accessToken) {
  return apiRequest("/biometric-devices", {
    method: "POST",
    body,
    accessToken,
  });
}

export function updateBiometricDevice(deviceId, body, accessToken) {
  return apiRequest(`/biometric-devices/${deviceId}`, {
    method: "PATCH",
    body,
    accessToken,
  });
}

export function getBiometricIdentities(deviceId, accessToken) {
  return apiRequest(`/biometric-devices/${deviceId}/identities`, {
    accessToken,
  });
}

export function createBiometricIdentity(deviceId, body, accessToken) {
  return apiRequest(`/biometric-devices/${deviceId}/identities`, {
    method: "POST",
    body,
    accessToken,
  });
}

export function updateBiometricIdentity(identityId, body, accessToken) {
  return apiRequest(`/biometric-devices/identities/${identityId}`, {
    method: "PATCH",
    body,
    accessToken,
  });
}